import { isEmpty } from 'lodash';
import React, { useRef, useEffect } from 'react';

const MessageEditor = ({ currentMessage, setCurrentMessage, addReply }) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto'; // reset height
      textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px'; // expand
    }
  }, [currentMessage]);

  return (
    <div>
      <textarea
        ref={textareaRef}
        value={currentMessage}
        onChange={(e) => setCurrentMessage(e.target.value)}
        className="form-control chat-input pe-5 resize-none overflow-hidden"
        placeholder="Enter message..."
        style={{
          borderRadius: '6px',
          resize: 'none',
          overflow: 'hidden',
        }}
        rows={1}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
            if (!isEmpty(currentMessage)) {
              e.preventDefault();
              addReply();
            }
          }
        }}
      />
    </div>
  );
};

export default MessageEditor;
